import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Fade } from "react-awesome-reveal";
import "swiper/css";

import MiniCard from "../home/MiniCard";
import SliderLine from "../home/SliderLine";

const CARDS = [
  { titleKey: "whyUs.mindset.card1.title", textKey: "whyUs.mindset.card1.text" },
  { titleKey: "whyUs.mindset.card2.title", textKey: "whyUs.mindset.card2.text" },
  { titleKey: "whyUs.mindset.card3.title", textKey: "whyUs.mindset.card3.text" },
  { titleKey: "whyUs.mindset.card4.title", textKey: "whyUs.mindset.card4.text" },
];

function Mindset() {
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  const [current, setCurrent] = useState(0);

  return (
    <section className="mt">
      <div className="glcontainer">
        <div className="flex flex-col sm:flex-row sm:items-start gap-[25px] sm:gap-[40px] lg:gap-[62px]">
          {/* Слева: заголовок */}
          <Fade triggerOnce direction="left" duration={700} className="sm:flex-1">
          <div className="flex flex-col items-start">
            <div className="flex flex-col gap-[4px]">
              <h2 className="font-42-28">{t("whyUs.mindset.title1")}</h2>
              <h3 className="font-32-22">{t("whyUs.mindset.title2")}</h3>
            </div>
            <p className="mt-[15px] font-16-14 max-w-[434px]">{t("whyUs.mindset.subtitle")}</p>
          </div>
          </Fade>

          {/* Справа: 2x2 карточки (desktop / tablet) */}
          <div className="hidden sm:grid grid-cols-2 gap-[20px] sm:w-[62%] lg:w-[718px] shrink-0">
            {CARDS.map((card, i) => (
              <MiniCard key={i} title={t(card.titleKey)} text={t(card.textKey)} />
            ))}
          </div>

          {/* Мобильный слайдер */}
          <div className="sm:hidden w-full">
            <Swiper
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={(swiper) => setCurrent(swiper.realIndex)}
              spaceBetween={16}
              slidesPerView={1}
              grabCursor
            >
              {CARDS.map((card, i) => (
                <SwiperSlide key={i}>
                  <MiniCard title={t(card.titleKey)} text={t(card.textKey)} />
                </SwiperSlide>
              ))}
            </Swiper>
            <SliderLine
              current={current}
              total={CARDS.length}
              onPrev={() => swiperRef.current?.slidePrev()}
              onNext={() => swiperRef.current?.slideNext()}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Mindset;
